import { render, staticRenderFns } from "./add-lag.vue?vue&type=template&id=10b44fda"
import script from "./add-lag.vue?vue&type=script&lang=js"
export * from "./add-lag.vue?vue&type=script&lang=js"
import style0 from "./add-lag.vue?vue&type=style&index=0&id=10b44fda&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b44fda')) {
      api.createRecord('10b44fda', component.options)
    } else {
      api.reload('10b44fda', component.options)
    }
    module.hot.accept("./add-lag.vue?vue&type=template&id=10b44fda", function () {
      api.rerender('10b44fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/version-list/add-lag.vue"
export default component.exports